import axios from 'axios'

export default {
  async getPdfs (params) {
    return await axios.get('/api/spa/v1/pdfs', params)
  },
  async uploadPdf (params) {
    return await axios.post('/api/spa/v1/pdf', params)
  },
  async deletePdf (params) {
    return await axios.delete('/api/spa/v1/pdf/' + params.id, params)
  },
  async updatePdf (params) {
    return await axios.put('/api/spa/v1/pdf/' + params.id, params)
  }
}
